/**
 * Centralized configuration for HubSpot form embedding.
 */
export const HUBSPOT_FORM = {
  PORTAL_ID: '43762772',
  REGION: 'na1',
  SCRIPT_ID: 'hubspot-embed-43762772',
  SCRIPT_SRC: 'https://js.hsforms.net/forms/embed/43762772.js',
  FORMS: {
    RECIPIENT_ONBOARDING: '55d5f5a5-a5cc-450e-8b37-11a25022cb6a',
  },
  EVENTS: {
    ON_READY: 'hs-form-event:on-ready',
    ON_SUBMISSION_SUCCESS: 'hs-form-event:on-submission:success',
    ON_NAVIGATE_NEXT: 'hs-form-event:on-interaction:navigate:next',
    ON_NAVIGATE_PREVIOUS: 'hs-form-event:on-interaction:navigate:previous',
  },
  TOTAL_STEPS: 4,
} as const;
